import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import sr from "./sr.json";

const COOKIE_NAME = "RasporediMe.Localization.CultureName";

function getStoredLanguage(): string {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  const value = match ? decodeURIComponent(match[1]) : "";
  // Only switch to English if explicitly set via the language switcher
  if (value.startsWith("en")) return "en";
  return "sr";
}

function setLanguageCookie(lang: string) {
  const expires = new Date(Date.now() + 5 * 365 * 86400000).toUTCString();
  document.cookie = `${COOKIE_NAME}=${lang}; expires=${expires}; path=/`;
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    sr: { translation: sr },
  },
  lng: getStoredLanguage(),
  fallbackLng: "sr",
  interpolation: {
    escapeValue: false,
  },
});

// Keep cookie in sync when language changes
i18n.on("languageChanged", (lng) => {
  setLanguageCookie(lng);
});

export { getStoredLanguage, setLanguageCookie };
export default i18n;
